var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',{staticClass:"thank-you"},[_vm._v("Thank you for your purchase!")]),_c('p',{staticClass:"message"},[_vm._v("We have successfully added credits to your account")]),_c('router-link',{staticClass:"btn",attrs:{"to":"/brand-checker"}},[_vm._v("Start Searching")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }